import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { Subject } from 'rxjs';


import { DataService } from './../../data.service';

@Injectable({
  providedIn: 'root'
})
export class ApplicationViewService {

  constructor(private dataService: DataService) { }

  getAppSettings(applicationName):Observable<any> {

    var subject = new Subject<any>();
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid:localStorage.getItem("crm_userid"),
      username:localStorage.getItem("crm_username"),
      data: {
        appsettings: {
          appname: applicationName
        }
      }
    }

    this.dataService.getAppSettingsByName(postOption).subscribe(
      res => {
          subject.next(res);
          console.log(subject);
      },
      err =>{
        subject.next(err);
      }

    );
    return subject.asObservable();
  }

}
